import { ResponseError } from '@marketplace-web/shared/api-client'
import { getCreateSupportTicketArgs } from 'data/api/transformers/arguments/get-create-support-ticket-args'
import { CreateSupportTicketArgs } from 'types/api/arguments/create-support-ticket-args'
import { SubmitTicketResp } from 'types/api/response/submit-ticket-resp'

import { api } from './api'

export const createSupportTicket = (args: CreateSupportTicketArgs) =>
  api.post<SubmitTicketResp, ResponseError>(
    '/help_center/support_tickets',
    getCreateSupportTicketArgs(args),
  )
